import MuiTextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Box from "@mui/system/Box";
import styled from "styled-components";

export const Container = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const Input = styled(MuiTextField)`
  width: 100%;
`;

export const ErrorMessage = styled(Typography)`
  color: rgb(244, 67, 54);
  font-family: Roboto, Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.66;
  letter-spacing: 0.03333em;
  text-align: left;
  margin: -10px 0px 0px;
`;
